import React from 'react';
import Independentlearning_k13 from './independentlearning_k13';
import Independentlearning_k13_subjects from './independentlearning_k13_subjects';
const Independentlearning_k13soc = () => {
  return (
    <div>
      <Independentlearning_k13 />
    <Independentlearning_k13_subjects />
    <div className='relative right-0 left-0 top-37 '>
      <h1>Social studies section for independent learning</h1>
      <h3>Social studies section in the curriculum</h3>
      <li>Generic skills or Soft skills or 21st century skills integrated in agriculture learning and assessment </li>
      <li>Cross-cutting isues integrated in Agriculture learning and assessment </li>
      <li>Values integrated in Agriculture learning and assessment </li>
      </div>
    </div>
  );
}

export default Independentlearning_k13soc;